import { render, staticRenderFns } from "./ProjectTalkLoading.vue?vue&type=template&id=b9413bbc&scoped=true&"
var script = {}
import style0 from "./ProjectTalkLoading.vue?vue&type=style&index=0&id=b9413bbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9413bbc",
  null
  
)

export default component.exports